import { Badge, Flex, Spacing, ToggleGroup, ToggleGroupItem } from '@billy/design-system'
import { ChangeEvent, ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FecAccountMappingFilter } from '../../../../../../enums/fecAccountMappingFilter'

interface ChartOfAccountsFilterToggleProps {
  newCount: number
  onChange: (filter: FecAccountMappingFilter) => void
  value: FecAccountMappingFilter
}

export const ChartOfAccountsFilterToggle = ({
  newCount,
  onChange,
  value,
}: ChartOfAccountsFilterToggleProps): ReactElement => {
  const { t } = useTranslation()

  const items: ToggleGroupItem[] = useMemo(
    () => [
      {
        label: (
          <Flex alignItems="center" gap={Spacing.S8}>
            <span>
              {t('settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.filter.new')}
            </span>
            <Badge>{newCount}</Badge>
          </Flex>
        ),
        value: FecAccountMappingFilter.New,
      },
      {
        label: t('settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.filter.all'),
        value: FecAccountMappingFilter.All,
      },
    ],
    [newCount, t],
  )

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.currentTarget.value as FecAccountMappingFilter)
  }

  return <ToggleGroup items={items} onChange={handleChange} value={value} />
}
